export default __webpack_public_path__ + "static/media/edit.3f1da29b.svg";